import { CoexistenceCarInfo, CoexistenceDriverInfo, CoexistenceOrganizationInfo } from '../../API';
import { CarInfo, DriverInfo, OrganizationInfo } from '../type/MasterInfoType';

export const convertOrganizationInfoList = (apiResponseList: CoexistenceOrganizationInfo[]): OrganizationInfo[] => {
	const organizationInfoList: OrganizationInfo[] = [];
	apiResponseList.map((value) => {
		const organizationInfo: OrganizationInfo = {
			organizationId: value.organizationId || '',
			organizationName: value.organizationName || '',
		};
		organizationInfoList.push(organizationInfo);
	});

	return organizationInfoList;
};

export const convertCarInfoList = (apiResponseList: CoexistenceCarInfo[]): CarInfo[] => {
	const carInfoList: CarInfo[] = [];
	apiResponseList.map((value) => {
		const carInfo: CarInfo = {
			carId: value.carId || '',
			carCode: value.carCode || '',
			numberPlate: value.numberPlate || '',
			organizationName: value.organizationName || '',
		};
		carInfoList.push(carInfo);
	});

	return carInfoList;
};

export const convertDriverInfoList = (apiResponseList: CoexistenceDriverInfo[]): DriverInfo[] => {
	const driverInfoList: DriverInfo[] = [];
	apiResponseList.map((value) => {
		const driverInfo: DriverInfo = {
			driverId: value.driverId || '',
			driverName: value.driverName || '',
		};
		driverInfoList.push(driverInfo);
	});

	return driverInfoList;
};
